<template>
<div class="header-main-pc">

    <div class="header-left">
        <router-link :to="'/'" style="text-decoration: none;" class="logo op-trk-event">
            <img src="../assets/logoo.png" style="width: 130px;">
        </router-link>
        <!-- <a href="index.html" class="logo op-trk-event">
            <img src="logoo.png" style="width: 130px;">
        </a> -->
        <ul class="nav">

            <li class="op-trk-event">
                <router-link :to="'/product'" style="text-decoration: none;">产品列表</router-link>
            </li>

            <li class="op-trk-event">
                <router-link :to="'/solution'" style="text-decoration: none;">解决方案</router-link>
            </li>

            <li class="op-trk-event">
                <router-link :to="'/about'" style="text-decoration: none;">关于我们</router-link>
            </li>

            <li class="op-trk-event">
                <a href="https://ypt.inrunonline.com/admin/login" target="_blank">IOT平台</a>
            </li>

        </ul>
    </div>

    <div class="header-right">
        <ul class="nav">
             <li class="op-trk-event">
                <a href="https://1za8f8zfx4f14jid0r58qo8js6ximp9.taobao.com/shop/view_shop.htm?appUid=RAzN8HWUksXq69UVsmUrkQ8XTQbX9b3SzBiAhgedvtZ2UcrYfV8&spm=a21n57.1.hoverItem.46" 
                   target="_blank">官方商店</a>
            </li>
            
            <li class="op-trk-event">
                <a href="https://work.weixin.qq.com/kfid/kfc61dad33e55eb5537" target="_blank">在线客服</a>
            </li>
        </ul>
    </div>
</div>
<div class="header-main-mo">
    <div class="header-first">
        <div class="first-nav">
            <router-link :to="'/'" class="nav-logo op-trk-event">
                <img src="../assets/logoo.png" style="width: 130px;">
            </router-link>

            <ul class="header-box-right">
                <li class="nav-menu" @click="menuShow()"><em class="fill"></em></li>
            </ul>
        </div>
    </div>
    <div class="header-menu" v-if="show">
        <div class="header-menu-box" style="height: auto;">
            <ul class="second-nav">
                <!-- <li>
                    <p class="second-nav-title op-trk-event">产品列表</p>
                </li>
                <li>
                    <p class="second-nav-title op-trk-event">解决方案</p>
                </li>
                <li>
                    <p class="second-nav-title op-trk-event">关于我们</p>
                </li> -->
                

                <li>
                    <router-link class="second-nav-title op-trk-event" :to="'/product'" style="text-decoration: none;">产品列表</router-link>
                </li>

                <li>
                    <router-link class="second-nav-title op-trk-event" :to="'/solution'" style="text-decoration: none;">解决方案</router-link>
                </li>

                <li>
                    <router-link class="second-nav-title op-trk-event" :to="'/about'" style="text-decoration: none;">关于我们</router-link>
                </li>
            </ul>
            
        </div>
    </div>
    
</div>
</template>

<script>
export default {
   
    data() {
        return {
            show:false,
        }
    },
    created() {
        
    },
    methods: {
        menuShow(){
            this.show = !this.show
        }
    }
}
</script>

<style scoped>
.header-v2 .header-main-pc .header-right .nav {
    display: flex;
}

.header-v2 .header-main-pc .header-right .nav>li>a {
    padding: 0 12px;
    position: relative;
    display: block;
    font-family: 'OPPOSans-Ver2-Medium';
    font-variation-settings: 'wght' 750;
    font-size: 14px;
    line-height: 52px;
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.55);
    transition: color .2s cubic-bezier(0.4, 0.8, 0.74, 1)
}

.header-v2 .header-main-pc .header-right>div,
.header-v2 .header-main-pc .header-right>ul {
    display: flex;
    cursor: pointer;
}
</style>